/**
 * Valores de status da auditoria (alinhados ao mock e à API de UI)
 */
export const AUDIT_STATUS = {
    PENDING: "pending",
    APPROVED: "approved",
    REJECTED: "rejected",
}

/** Rótulos de status na lista / badge */
export const AUDIT_STATUS_LABEL = {
    [AUDIT_STATUS.PENDING]: "Pendente",
    [AUDIT_STATUS.APPROVED]: "Aprovada",
    [AUDIT_STATUS.REJECTED]: "Reprovada",
}
